import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { translate } from "react-i18next";
class MessageComponent extends React.Component {
  componentDidUpdate() {
    if (this.props.message !== "" && this.props.type !== "") {
      switch (this.props.type) {
        case "success":
          toast.success(this.props.t(this.props.message), {
            onClose: this.props.clear
          });
          break;
        case "warning":
          toast.warn(this.props.t(this.props.message), {
            onClose: this.props.clear
          });
          break;
        case "error":
          toast.error(this.props.t(this.props.message), {
            onClose: this.props.clear
          });
          break;
        default:
          break;
      }
    }
  }

  render() {
    return <ToastContainer autoClose={8000} hideProgressBar />;
  }
}

export default translate("translations")(MessageComponent);



// WEBPACK FOOTER //
// ./src/components/MessageComponent.js